import { v4 as uuidv4 } from 'uuid';
import { Div, Link, MultilineInput, Snack, Span, TextInput } from "@tblabs/truffle";
import { ApplyForm } from "../Models/ApplyForm";
import { Recruit } from "../Models/Recruit";
import { Center } from "../Components/Center";
import { DangerButton } from "../Components/DangerButton";
import { Page } from "./Page";
import { Panel } from "../Components/Panel";
import { OffersRepo } from "../Services/OffersRepo";
import { ApplysRepo } from "../Services/ApplysRepo";


export class OfferApplyPage extends Page
{
    constructor(
        private _offers: OffersRepo,
        private _applys: ApplysRepo,
        private offerId: string)
    {
        super("Formularz aplikacji");

        this.Content(async () =>
        {
            const offer = await this._offers.Get(this.offerId);

            const recruit = new Recruit();

            this.body.Append(
                new Panel(
                    new Div().Append(
                        new Span("Aplikacja na stanowisko").FontSize(22).Normal(), " ",
                        new Link(offer.Title.value, "#job/" + this.offerId).FontSize(28).Bold()
                    ), [
                    new Span(`Odpowiedz na poniższe pytania w najbardziej zwięzły sposób w jaki potrafisz.`).Italic().Color("#d2d2d2"),
                ]),

                (offer.Form.Count == 0) && new Center("Brak pytań"),
                ...offer.Form.Items
                    .map(x => new Panel(x.Question.value, [
                        new MultilineInput(x.Answer).Rows(6).Placeholder("Miejsce na Twoją odpowiedź")
                    ])),

                new Panel("Twoje dane kontaktowe",
                    [
                        new TextInput(recruit.Name).Placeholder("Imię"),
                        new TextInput(recruit.Phone).Placeholder("Telefon").MarginTop(8),
                        new TextInput(recruit.Email).Placeholder("Email").MarginTop(8),
                        new TextInput(recruit.City).Placeholder("Miasto").MarginTop(8),
                    ]
                ),

                new Center(
                    new DangerButton("Wyślij!").OnClick(async (btn) =>
                    {
                        if (!recruit.Email.value)
                        {
                            new Snack("⚠️ Brak danych kontaktowych", "Wymagany jest chociaż email", { autoCloseTimeout: 5000, clickAnywhereToClose: true })
                            return;
                        }

                        btn.Disabled();

                        const applyForm = new ApplyForm(uuidv4());
                        applyForm.Position = offer.Title.value;
                        applyForm.Answers = offer.Form;
                        applyForm.Recruit = recruit;
                        applyForm.CreatedAt = new Date();

                        try
                        {
                            await this._applys.Add(applyForm);
                            
                            new Snack("Aplikacja wysłana!", "Dziękujemy 🩷", { autoCloseTimeout: 0 });
                        }
                        catch (ex: any)
                        {
                            new Snack("❌ Błąd", ex.message.includes("Unauthorized") ? "Brak autoryzacji" : "Nie udało się wysłać zgłoszenia", { autoCloseTimeout: 0, clickAnywhereToClose: false })
                        }
                    })
                ).MarginTop(32),
            )
        });
    }
}
